// ========================================
// The Lie Detective - Site Content Data
// ========================================

export const images = {
  hero: "https://customer-assets.emergentagent.com/job_polygraph-pro/artifacts/g88k91cu_Image%20Home%20Page.jpeg",
  logo: "https://customer-assets.emergentagent.com/job_polygraph-pro/artifacts/kgdlh1mi_Gemini_Generated_Image_syuliasyuliasyul.png",
  desk: "https://customer-assets.emergentagent.com/job_polygraph-pro/artifacts/swt550al_WhatsApp%20Image%202026-02-14%20at%2022.07.02%20%281%29.jpeg",
  detective: "https://customer-assets.emergentagent.com/job_polygraph-pro/artifacts/r0eudgct_WhatsApp%20Image%202026-02-14%20at%2022.07.02%20%282%29.jpeg",
  evidenceBoard: "https://customer-assets.emergentagent.com/job_polygraph-pro/artifacts/ydwpbuhl_WhatsApp%20Image%202026-02-14%20at%2022.07.02.jpeg",
  corporate: "https://images.unsplash.com/photo-1657643538821-1ce539a789bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBpbnZlc3RpZ2F0aW9ufGVufDB8fHx8MTc3MTE1NDYzNHww&ixlib=rb-4.1.0&q=85",
  magnifyingGlass: "https://images.unsplash.com/photo-1626148749358-5b3b3f45b41a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxkZXRlY3RpdmUlMjBpbnZlc3RpZ2F0aW9ufGVufDB8fHx8MTc3MTE1NDY0OHww&ixlib=rb-4.1.0&q=85",
  office: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBvZmZpY2V8ZW58MHx8fHwxNzcxMTU0NjQzfDA&ixlib=rb-4.1.0&q=85",
};

export const siteInfo = {
  name: "The Lie Detective",
  tagline: "Truth. Integrity. Clarity.",
  phone: "+27 XX XXX XXXX",
  email: "info@theliedetective.co.za",
  location: "Gauteng, South Africa",
  hours: "Mon–Fri: 8:00 AM – 6:00 PM | Sat: By appointment",
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Who Needs This", path: "/who-needs-this" },
  { label: "How It Works", path: "/how-it-works" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];

export const stats = [
  { value: "17k+", label: "Tests Conducted" },
  { value: "100%", label: "Confidential" },
  { value: "20+", label: "Years Experience" },
  { value: "98%", label: "Client Satisfaction" },
];

export const services = [
  {
    id: "employment-hr",
    icon: "Briefcase",
    title: "Employment & HR",
    shortDescription: "Comprehensive polygraph screening for hiring, promotions, and high-risk roles to safeguard your organisation.",
    features: [
      "Pre-employment screening",
      "Periodic employee assessments",
      "Promotion and transfer evaluations",
      "High-risk role vetting",
    ],
  },
  {
    id: "corporate-investigations",
    icon: "SearchCheck",
    title: "Corporate Investigations",
    shortDescription: "Uncover the truth behind workplace theft, fraud, misconduct, and information leaks with scientific precision.",
    features: [
      "Theft and asset misappropriation",
      "Financial fraud detection",
      "Workplace misconduct",
      "Confidential information leaks",
    ],
  },
  {
    id: "legal-professional",
    icon: "Scale",
    title: "Legal & Professional",
    shortDescription: "Supporting legal proceedings and internal investigations with reliable, admissible polygraph examinations.",
    features: [
      "Attorney-requested examinations",
      "Internal investigation support",
      "Case preparation assistance",
      "Expert testimony availability",
    ],
  },
  {
    id: "private-matters",
    icon: "Heart",
    title: "Private Matters",
    shortDescription: "Discreet and compassionate polygraph testing for personal concerns including relationship issues and family disputes.",
    features: [
      "Relationship and infidelity concerns",
      "Family disputes and trust issues",
      "Personal verification needs",
      "Confidential individual testing",
    ],
  },
  {
    id: "custom-requests",
    icon: "Settings",
    title: "Custom Requests",
    shortDescription: "Tailored polygraph packages designed to meet your unique requirements, whatever the situation demands.",
    features: [
      "Customised testing protocols",
      "Multi-session packages",
      "Group testing arrangements",
      "Specialised investigation support",
    ],
  },
];

export const audiences = [
  {
    id: "corporate-hr",
    icon: "Building2",
    title: "Corporate & HR",
    description: "Protect your business interests and maintain a trustworthy workforce with professional polygraph screening.",
    scenarios: [
      {
        title: "Pre-Employment Screening",
        example: "A financial services company needs to verify the integrity of candidates for positions handling sensitive client data.",
        outcome: "Identify high-risk candidates before they gain access to confidential information, reducing insider threats by up to 80%.",
      },
      {
        title: "Periodic Screening",
        example: "A logistics company suspects ongoing inventory shrinkage but cannot identify the source through conventional auditing.",
        outcome: "Regular polygraph assessments help deter dishonest behaviour and quickly identify individuals involved in theft.",
      },
      {
        title: "Incident Investigation",
        example: "A manufacturing firm experiences a significant theft of raw materials and needs to narrow down the pool of suspects.",
        outcome: "Focused polygraph testing helps investigators identify the responsible parties, recovering losses and restoring workplace trust.",
      },
    ],
  },
  {
    id: "legal",
    icon: "Gavel",
    title: "Legal Professionals",
    description: "Strengthen your legal strategy with scientifically-backed polygraph examinations that support case preparation.",
    scenarios: [
      {
        title: "Attorney-Requested Testing",
        example: "A defence attorney needs to assess the credibility of their client's account before trial preparation.",
        outcome: "Polygraph results inform legal strategy, helping attorneys build stronger cases based on verified truthfulness.",
      },
      {
        title: "Case Preparation Support",
        example: "An insurance company suspects fraudulent claims and needs additional evidence to support their investigation.",
        outcome: "Polygraph examinations provide an additional layer of due diligence, supporting or refuting claim legitimacy.",
      },
    ],
  },
  {
    id: "security",
    icon: "ShieldCheck",
    title: "Security & Investigations",
    description: "Enhance your security protocols with polygraph verification for personnel screening and investigation support.",
    scenarios: [
      {
        title: "Security Personnel Vetting",
        example: "A private security firm needs to verify the backgrounds and intentions of applicants for high-security positions.",
        outcome: "Thorough polygraph screening ensures only trustworthy individuals are placed in sensitive security roles.",
      },
      {
        title: "Investigation Verification",
        example: "A private investigator needs to verify witness statements in a complex corporate espionage case.",
        outcome: "Polygraph testing helps separate truthful accounts from deception, accelerating investigation timelines.",
      },
    ],
  },
  {
    id: "private",
    icon: "Users",
    title: "Private Individuals",
    description: "Resolve personal concerns with confidential, compassionate polygraph testing conducted in a safe environment.",
    scenarios: [
      {
        title: "Relationship Concerns",
        example: "A spouse suspects infidelity and needs clarity before making life-changing decisions about their relationship.",
        outcome: "Discreet testing provides definitive answers, enabling informed decision-making with confidence and peace of mind.",
      },
      {
        title: "Family Matters",
        example: "Family members dispute the circumstances of a financial arrangement or inheritance matter.",
        outcome: "Polygraph testing helps resolve disputes objectively, preserving family relationships through verified truth.",
      },
      {
        title: "Personal Verification",
        example: "An individual accused of wrongdoing wants to clear their name and prove their innocence.",
        outcome: "Voluntary polygraph testing provides credible evidence of truthfulness, restoring reputation and trust.",
      },
    ],
  },
];

export const howItWorksSteps = [
  {
    number: "01",
    title: "Initial Consultation",
    description: "Contact us to discuss your requirements. We'll assess your situation, explain the process, and determine the most appropriate testing approach for your needs.",
  },
  {
    number: "02",
    title: "Pre-Test Interview",
    description: "Before the examination, we conduct a thorough pre-test interview to establish rapport, review all questions, and ensure the examinee understands the process completely.",
  },
  {
    number: "03",
    title: "The Examination",
    description: "Using state-of-the-art computerised polygraph equipment, we conduct the examination in a controlled, comfortable environment. The test typically takes 90–120 minutes.",
  },
  {
    number: "04",
    title: "Analysis & Scoring",
    description: "Our certified examiner analyses the physiological data using validated scoring algorithms and professional expertise to determine truthfulness or deception.",
  },
  {
    number: "05",
    title: "Confidential Report",
    description: "You receive a comprehensive, confidential report detailing the examination findings, conclusions, and any relevant observations — delivered within 24–48 hours.",
  },
];

export const faqItems = [
  {
    question: "What is a polygraph examination?",
    answer: "A polygraph examination, commonly known as a lie detector test, is a scientific procedure that measures and records physiological responses — such as blood pressure, heart rate, respiration, and skin conductivity — while a person answers a series of questions. These measurements help a trained examiner determine if the individual is being truthful or deceptive.",
  },
  {
    question: "How accurate is polygraph testing?",
    answer: "Modern computerised polygraph testing, when conducted by a certified and experienced examiner, achieves accuracy rates of 87–95%. The American Polygraph Association reports that validated testing techniques consistently demonstrate high reliability in both research and field settings.",
  },
  {
    question: "Is the test painful or invasive?",
    answer: "Not at all. The polygraph examination is completely non-invasive. Small sensors are placed on the fingertips, around the chest, and on the upper arm (similar to a blood pressure cuff). There is no pain or discomfort involved in the process.",
  },
  {
    question: "How long does a polygraph examination take?",
    answer: "A typical examination takes between 90 minutes and 2 hours. This includes the pre-test interview, the actual examination, and a post-test discussion. The actual physiological recording portion usually lasts 15–20 minutes.",
  },
  {
    question: "Are polygraph results admissible in South African courts?",
    answer: "While polygraph results are not automatically admissible as evidence in South African courts, they are increasingly used in disciplinary hearings, arbitrations, and as a supporting investigative tool. Results can also be submitted as evidence with the agreement of both parties.",
  },
  {
    question: "What should I do to prepare for a polygraph test?",
    answer: "Get a good night's sleep, eat normally, and take any prescribed medications as usual. Avoid excessive caffeine or alcohol before the test. Most importantly, arrive with an open mind — the process will be thoroughly explained before any testing begins.",
  },
  {
    question: "Is the process confidential?",
    answer: "Absolutely. All examinations and results are treated with the strictest confidentiality. Reports are only shared with the authorised requesting party. We adhere to the Protection of Personal Information Act (POPIA) and maintain rigorous data protection standards.",
  },
  {
    question: "Can someone 'beat' a polygraph test?",
    answer: "While there are myths about beating a polygraph, a certified examiner trained in countermeasure detection can identify most attempts to manipulate results. Modern computerised equipment and validated questioning techniques make it extremely difficult to produce false results.",
  },
];

export const whyChooseUs = [
  {
    icon: "Award",
    title: "Certified Examiner",
    description: "Fully certified polygraph examiner with extensive training and ongoing professional development.",
  },
  {
    icon: "Lock",
    title: "100% Confidential",
    description: "Your privacy is paramount. All consultations, examinations, and results are handled with absolute discretion.",
  },
  {
    icon: "Monitor",
    title: "Modern Equipment",
    description: "State-of-the-art computerised polygraph systems ensuring the highest accuracy and reliability.",
  },
  {
    icon: "Clock",
    title: "Fast Turnaround",
    description: "Comprehensive reports delivered within 24–48 hours of examination completion.",
  },
];

export const serviceOptions = [
  "Employment & HR Screening",
  "Corporate Investigation",
  "Legal & Professional",
  "Private Matter",
  "Custom Request",
  "Other",
];
